import Container from "../element/container";
import "./login.consent.scss";
import { useField } from "formik";
import { useTranslation } from "react-i18next";

export default function LoginConsent() {
  const [field] = useField({ name: "acceptedPolicies", type: "checkbox" });
  const { t } = useTranslation();
  return (
    <Container tag="div" className="login-consent">
      <label>
        <input {...field} type="checkbox" />
        <span>
          {t("I agree to the")} {" "}
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">{t("Privacy Policy")}</a>
          {" "}{t("and")}{" "}
          <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">{t("Terms & Conditions")}</a>.
        </span>
      </label>
    </Container>
  );
}
